import url                           from '../../../utils/url.js'
import { MAP, TREADS_POLY_SUBCOLOR } from '@/config/map'
import { STATUS }                    from '@/config/config'
import ObjectDrawer                  from '../utils/ObjectDrawer.js'
import year                          from '../../../utils/year.js'
import { map as mapEndpoints }       from '../../../api/api-endpoints'
import { OBJECT }                    from '@/utils/map/types'
import mapMixin                      from '../../../mixins/map-mixin.js'
import { POLYGON }                   from '@/config/polygon'
import L                             from 'leaflet'

export default {
  mixins: [mapMixin],
  data() {
    this.map          = null
    this.objectDrawer = null
    return {
      popup_tariff:       null,
      showObjectsAll:     false,
      showThreadsAll:     false,
      allowThreadTypes:   [],
      ignoreTKOLine:      false,
      ignoreOtherLine:    false,
      ignoreMixedLine:    false,
      ignoreStatusActive: false,
      ignoreStatusPlan:   false,
      showModelTariffs:   false
    }
  },
  watch:    {
    '$route': 'routeHandler'
  },
  computed: {
    mapBorders() {
      return this.$store.getters.readUrlEndpoint(
        mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom)
      )
    },
    defaultZoom() {
      return 8
    },
    defaultTkoZoom() {
      return 10
    },
    mapBringTo() {
      return this.$store.getters.mapBringTo
    },
    updateMapStatus() {
      return this.$store.getters.updateMapStatus
    },
    contextmenu() {
      return true
    },
    contextmenuOpened() {
      return false
    },
    mapTariffs() {
      return this.$store.getters.readUrlEndpoint(this.getMapModelingRegionTariff())
    },
    threadsRawData() {
      let ep = this.getThreadEndpoint(this.$route)
      return this.$store.getters.readUrlEndpoint(ep)
    },
    threads() {
      return this.$store.getters.readUrlEndpoint(this.getThreadEndpoint(this.$route)) || []
    },
    heatMapFormedDistrict() {
      return this.$store.getters.readUrlEndpoint(mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom))
    },
    settlementsById() {
      let tmp         = {}
      let settlements = this.settlements
      for (const set of settlements) {
        tmp[set.id] = set
      }
      return tmp
    },
    settlementsData() {
      return this.$store.getters.readUrlEndpoint(this.getSettlementEndpoint(this.$route, {}))
    },
    settlements() {
      if (!this.settlementsData?.length) {
        return []
      }
      
      return this.settlementsData.map(set => {
        let showAfterZoom = this.defineShowAfterZoom(set)
        
        return ({ ...set, showAfterZoom, type: OBJECT.CITY })
      })
    },
    mapTkoObjectsById() {
      let tmp           = {}
      let mapTkoObjects = this.mapTkoObjects
      for (let key in mapTkoObjects) {
        for (const v of mapTkoObjects[key]) {
          if (this.ignoreStatusActive && v.status_id === STATUS.ACTIVE) {
            continue
          }
          if (this.ignoreStatusPlan && v.status_id === STATUS.PLANED) {
            continue
          }
          
          tmp[v.id]               = Object.assign(tmp[v.id] || {}, v)
          tmp[v.id].type          = OBJECT.TKO
          // TODO: default zoom
          tmp[v.id].showAfterZoom = 1
        }
      }
      return tmp
    },
    // TODO: return as array
    mapTkoObjects() {
      return this.$store.getters.readUrlEndpoint(this.getMapTkoObjectsEndpoint(this.$route))
    },
    garbageSourceData() {
      return this.$store.getters.readUrlEndpoint(this.getGarbageSourceEndpoint(this.$route, {}))
    },
    unauthorizedTkos() {
      let unauthorizedTkos = this.unauthorizedTkosData
      let tmp              = []
      for (let key in unauthorizedTkos) {
        let unauthorizedTko = unauthorizedTkos[key]
        let showAfterZoom   = this.defaultZoom
        
        tmp.push(Object.assign({}, unauthorizedTko, {
          showAfterZoom: showAfterZoom,
          type:          OBJECT.UNAUTHORIZED_TKO
        }))
      }
      return tmp
    },
    unauthorizedHeaps() {
      let unauthorizedHeaps = this.unauthorizedHeapsData
      let tmp               = []
      for (let key in unauthorizedHeaps) {
        let unauthorizedHeap = unauthorizedHeaps[key]
        let showAfterZoom    = this.defaultZoom
        
        tmp.push(Object.assign({}, unauthorizedHeap, {
          showAfterZoom: showAfterZoom,
          type:          OBJECT.OFFLINE
        }))
      }
      return tmp
    },
    msnContainers() {
      let msnContainers = this.msnData
      let tmp           = []
      for (let key in msnContainers) {
        let msnContainer  = msnContainers[key]
        let showAfterZoom = this.defaultZoom
        
        tmp.push(Object.assign({}, msnContainer, {
          showAfterZoom,
          type: OBJECT.OFFLINE
        }))
      }
      return tmp
    },
    unauthorizedTkosData() {
      return this.$store.getters.readUrlEndpoint(this.getUnauthorizedTkosEndpoint(this.$route, {}))
    },
    unauthorizedHeapsData() {
      return this.$store.getters.readUrlEndpoint(this.getUnauthorizedHeapsEndpoint(this.$route, {}))
    },
    msnData() {
      return this.$store.getters.readUrlEndpoint(this.getMSNContainersEndpoint(this.$route, {}))
    },
    garbageSources() {
      if (!this.garbageSourceData?.length) {
        return []
      }
      let showAfterZoom = this.defaultZoom
      return this.garbageSourceData.map(garbageSource => ({ ...garbageSource, showAfterZoom, type: OBJECT.GARBAGE }))
    },
    garbageSourcesById() {
      let tmp            = {}
      let garbageSources = this.garbageSources
      for (const garbageSource of garbageSources) {
        tmp[garbageSource.id] = garbageSource
      }
      return tmp
    },
    relations() {
      const threads = this?.threads ? Object.values(this.threads) : []
      if (!threads?.length) {
        return []
      }
      const nodes             = []
      const tkoMinZoom        = {}
      const settlements       = this.settlementsById
      const garbageSources    = this.garbageSourcesById
      const mapTkoObjectsById = this.mapTkoObjectsById
      let threadData = this.$store.state.threadConstant.pointTypesColors;
      let colorArr = [];
      this.allowThreadTypes.forEach((el, ind) => {
        colorArr.push(threadData[el]);
      });
      for (const thread of threads) {
        if (colorArr.indexOf(thread.color.substr(1)) == -1) {
          continue;
        }
        if (thread.color === TREADS_POLY_SUBCOLOR.tko && this.ignoreTKOLine) {
          continue
        }
        if (thread.color === TREADS_POLY_SUBCOLOR.other && this.ignoreOtherLine) {
          continue
        }
        if (thread.color === TREADS_POLY_SUBCOLOR.mixed && this.ignoreMixedLine) {
          continue
        }
        
        let tko_obj = mapTkoObjectsById[thread.tko_object_id]
        
        if (!tko_obj) {
          continue
        }
        
        thread.status_id = tko_obj.status_id
        
        let relationType
        
        let set           = settlements[thread.settlement_id] ? settlements[thread.settlement_id] : {}
        let garbageSource = garbageSources[thread.garbage_source_id] ? garbageSources[thread.garbage_source_id] : {}
        
        if (set?.id) {
          relationType = 'settlement-object'
        }
        
        if (garbageSource?.id) {
          relationType = 'garbage_source-object'
        }
        
        let showAfterZoom = this.defaultZoom //8
        if (set?.id) {
          // если есть город исп для масштабирования
          showAfterZoom = set?.oldShowAfterZoom || set?.showAfterZoom
        }
        
        if (garbageSource?.id) {
          showAfterZoom = this.defaultZoom + 1
        }
        
        let endTkoId = thread?.tko_object_id
        let end      = Object.assign(thread, {
          type: OBJECT.TKO,
          id:   endTkoId,
          name: (thread?.name || thread?.object_name),
          lat:  (thread?.lat || thread?.object_lat),
          lng:  (thread?.lng || thread?.object_lng),
          showAfterZoom
        })
        
        let start                      = {}
        const isObjectToObjectRelation = !!thread?.start_tko_object_id
        if (set?.id || garbageSource?.id) {
          const model = garbageSource?.id ? garbageSource : set?.id ? set : {}
          start       = Object.assign({}, {
            ...model,
            type:       OBJECT.CITY,
            start_name: set?.name || garbageSource?.name,
            showAfterZoom
          })
        } else if (isObjectToObjectRelation) {
          // это связь город -> объект или объект -> объект
          const startTkoId = thread.start_tko_object_id || null
          
          let startTko = mapTkoObjectsById[startTkoId]
          
          if (!startTko) {
            continue
          }
          
          relationType = 'object-object'
          
          start = Object.assign(startTko, {
            type:          OBJECT.TKO,
            id:            startTkoId,
            lat:           thread?.start_object_lat,
            lng:           thread?.start_object_lng,
            start_name:    thread?.start_name || null,
            showAfterZoom: showAfterZoom,
            // для отображения загрузки объекта надо garbage_sum и power
            garbage_sum: thread.start_object_garbage_sum || null
          })
          
          tkoMinZoom[endTkoId] = 1
          tkoMinZoom[startTkoId] = 1
          
        } else {
          continue
        }
        
        // сообщение показ при наведение на связь
        let relationTooltip = ''
        relationTooltip += `${start.start_name} —> ${end.end_name}<br>`
        
        if (end.hasOwnProperty('garbage_value')) {
          relationTooltip += this.isBlank(end.garbage_value) + ' т/год '
        } else if (end.hasOwnProperty('total')) {
          relationTooltip += this.isBlank(end.total) + ' т/год '
        }
        
        if (end.hasOwnProperty('garbage_value_cubic')) {
          relationTooltip += this.isBlank(end.garbage_value_cubic) + ' куб.м/год '
        } else if (end.hasOwnProperty('total_cubic')) {
          relationTooltip += this.isBlank(end.total_cubic) + ' куб.м/год '
        }
        
        let distance     = 0
        let distanceInKM = 0
        
        if (!end.is_plan && end.hasOwnProperty('distance') && end.distance > 0) {
          distance     = end.distance
          distanceInKM = distance
        } else if (end.hasOwnProperty('planning_distance') && end.planning_distance > 0) {
          distance = end.planning_distance
        }
        
        if (distance) {
          distanceInKM = Math.round(distance / 1000)
          relationTooltip += distanceInKM + ' км '
        }
        
        end.relationTooltip = relationTooltip
        
        // для процент загрузки объекта нужен
        // power(мощность объекта) и garbage_sum(сумма всех отходов объекта)
        end.power       = end.power || null
        end.garbage_sum = end.garbage_sum || null
        
        // создания индекса с минимальным масштабами
        // для отображения по id объекта
        if (!tkoMinZoom[endTkoId]) {
          tkoMinZoom[endTkoId] = +showAfterZoom
        }
        
        if (showAfterZoom < tkoMinZoom[endTkoId]) {
          tkoMinZoom[endTkoId] = +showAfterZoom
        }
        
        nodes.push({ start, end, isObjectToObjectRelation, relationType })
      }
      
      // обновления значений масштаба исходя из мин значений
      for (let i = 0; i < nodes.length; i++) {
        if (tkoMinZoom[nodes[i].end.id]) {
          nodes[i].end.showAfterZoom = tkoMinZoom[nodes[i].end.id]
        }
        if (nodes[i].isObjectToObjectRelation) {
          if (tkoMinZoom[nodes[i].start.id]) {
            nodes[i].start.showAfterZoom = tkoMinZoom[nodes[i].start.id]
          }
        }
        if (this.showThreadsAll) {
          nodes[i].end.oldShowAfterZoom   = nodes[i].end.showAfterZoom
          nodes[i].end.showAfterZoom      = 1
          nodes[i].start.oldShowAfterZoom = nodes[i].start.showAfterZoom
          nodes[i].start.showAfterZoom    = 1
        }
      }
      
      return nodes
    }
  },
  methods:  {
    defineShowAfterZoom(set) {
      let showAfterZoom = this.defaultZoom
      
      // population zoom
      // http://redmine.etton.ru/issues/12160
      let zoomDictionary = { 98000: 1, 50000: 6, 10000: 7, 1000: 8, 300: 9, 100: 10 }
      if (!set?.population || set?.population === 0) {
        showAfterZoom = this.defaultZoom
      } else {
        for (const population in zoomDictionary) {
          showAfterZoom = set?.population > +population ? zoomDictionary[population] : showAfterZoom
        }
      }
      
      if (this.showObjectsAll) {
        showAfterZoom = 1
      }
      return showAfterZoom
    },
    isBlank(value) {
      if (!value || value === 0) {
        return value = ' - '
      }
      return value
    },
    getMapTkoObjectsEndpoint(route) {
      return mapEndpoints.objectForThreads(route)
    },
    getThreadEndpoint(route) {
      if (!route.query.year) {
        route.query.year = year.getCurrentYear()
      }
      if (!route.query?.flows) {
        route.query.flows = true
      }
      return mapEndpoints.threadsByYear(route)
    },
    getSettlementEndpoint(route) {
      return mapEndpoints.settlements(route)
    },
    getGarbageSourceEndpoint(route) {
      return mapEndpoints.garbageSources(route)
    },
    getUnauthorizedTkosEndpoint(route) {
      return mapEndpoints.unauthorizedObjectForThreads('', route)
    },
    getUnauthorizedHeapsEndpoint(route) {
      return mapEndpoints.heap('', route)
    },
    getMSNContainersEndpoint(route) {
      return mapEndpoints.msn('', route)
    },
    showAll(val) {
      this.$store.commit('preloaderStart')
      setTimeout(() => {
        this.showObjectsAll = val
        this.refreshMap()
        this.$store.commit('preloaderEnd')
      }, 200)
    },
    // показать/скрыть отдельные типы потоков ...
    showHideLine(vals) {
      this.$store.commit('preloaderStart');
      if (vals == null) {
        this.allowThreadTypes = [];
      } else {
        vals.forEach((val) => {
          let index = this.allowThreadTypes.indexOf(val);
          if (index == -1) {
            this.allowThreadTypes.push(val);
          } else {
            this.allowThreadTypes.splice(index, 1);
          }
        });
      }

      this.refreshMap();
      this.$store.commit('preloaderEnd');
    },
    /*showTKOLine(val) {
      this.$store.commit('preloaderStart')
      setTimeout(() => {
        this.ignoreTKOLine = !val
        this.refreshMap()
        this.$store.commit('preloaderEnd')
      }, 200)
    },
    showOtherLine(val) {
      this.$store.commit('preloaderStart')
      this.ignoreOtherLine = !val
      this.refreshMap()
      this.$store.commit('preloaderEnd')
    },
    showMixedLine(val) {
      this.$store.commit('preloaderStart')
      this.ignoreMixedLine = !val
      this.refreshMap()
      this.$store.commit('preloaderEnd')
    },*/
    showAllThreads(val) {
      this.$store.commit('preloaderStart')
      this.showThreadsAll = val
      this.refreshMap()
      this.$store.commit('preloaderEnd')
    },
    showModelTariffsHandle(val) {
      this.$store.commit('preloaderStart')
      this.showModelTariffs = val
      setTimeout(() => {
        if (this.showModelTariffs) {
          this.borderDrawer.drawLocality(this.mapTariffs, true)
          if (this.popup_tariff) {
            this.popup_tariff.remove()
          }
          this.popup_tariff = L.popup({
            maxHeight:    700,
            className:    'tooltip tooltip--top',
            bottomOffset: 50
          }).setLatLng(event.latlng).setContent(`<h1>Тарифы</h1>
                   Наименование: <b>${data.name || ' - '}</b><br />
                   Среднее расстояние транспортировки ТКО, км.: <b>${data.distance || ' - '}</b><br />
                   Тариф, руб.: <b>${data.tariff || data.tariff_data ? data.tariff_data.transport_tariff : ' - '}</b><br />
                   Затраты на оплату труда, руб.: <b>${data && data.tariff_data ? data.tariff_data.S_zp : ' - '}</b><br />
                   Затраты на отчисления на социальные нужды, руб.: <b>${data && data.tariff_data ? data.tariff_data.S_otch : ' - '}</b><br />
                   Амортизация, руб.: <b>${data && data.tariff_data ? data.tariff_data.S_va : ' - '}</b><br />
                   Затраты на материалы, руб.: <b>${data && data.tariff_data ? data.tariff_data.S_m : ' - '}</b><br />
                   Затраты на топливло, руб.: <b>${data && data.tariff_data ? data.tariff_data.S_t : ' - '}</b><br />
                   Затраты на ТОиР, руб.: <b>${data && data.tariff_data ? data.tariff_data.S_r : ' - '}</b><br />
                   Общеэксплуатационные расходы, руб.: <b>${data && data.tariff_data ? data.tariff_data.S_oer : ' - '}</b><br />
                   Прочие прямые расходы, руб.: <b>${data && data.tariff_data ? data.tariff_data.S_pr : ' - '}</b><br />
                   </p>`).openOn(this.map)
        } else {
          if (this.popup_tariff) {
            this.popup_tariff.remove()
          }
          this.borderDrawer.drawLocality(this.heatMapFormedDistrict, true)
        }
        this.refreshMap()
        this.$store.commit('preloaderEnd')
      }, 200)
    },
    showStatusActive(val) {
      this.$store.commit('preloaderStart')
      this.ignoreStatusActive = !val
      this.refreshMap()
      this.$store.commit('preloaderEnd')
      
    },
    showStatusPlan(val) {
      this.$store.commit('preloaderStart')
      this.ignoreStatusPlan = !val
      this.refreshMap()
      this.$store.commit('preloaderEnd')
    },
    getMapPolygon() {
      return POLYGON
    },
    // offline remove data
    removeRelationFromStore(relation) {
      let tmp = Object.assign({}, this.threadsRawData)
      tmp.threads.filter(v => v.id !== relation.thread_id)
      this.$store.commit('setEndpointData', {
        endpoint: this.getThreadEndpoint(this.$route, {}),
        data:     tmp
      })
    },
    afterMapInit() {
      this.objectDrawer = new ObjectDrawer(this.map, this)
    },
    getMapConfigData() {
      return MAP
    },
    setView(data) {
      if (this.map) {
        this.map.setView([data.lat, data.lng], data.zoom)
        if (data.refreshMap) {
          this.refreshMap()
        }
      }
    },
    updateMap() {
      if (this.threadsDrawer) {
        // console.log('updateMap: ' + JSON.stringify(data))
        let promises = []
        promises.push(this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getThreadEndpoint(
            { ...(this.$route?.query?.year) && { year: this.$route?.query?.year } }
          )
        }))
        // for show tko, after relation del from map
        promises.push(this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getMapTkoObjectsEndpoint(this.$route)
        }))
        
        this.$bar.start()
        Promise.all(promises).then(() => {
          this.refreshMap()
        }).finally(() => this.$bar.finish())
      }
    },
    setFiltersFromUrl() {
      let route = url.getRoute(this.$route)
      
      // TODO: create dynamic search model
      if (route.query.year) {
        this.year = +route.query.year
      } else {
        this.year = year.getCurrentYear()
      }
      
      this.q = route.query?.q || ''
    },
    refreshMap() {
      this.threadsDrawer && this.threadsDrawer.refreshMap(this.relations)
    },
    routeHandler(newVal, oldVal) {
      this.setFiltersFromUrl()
      const newZoom = newVal?.query?.zoom
      const oldZoom = oldVal?.query?.zoom
      if (
        newZoom !== oldZoom ||
        newVal?.query?.layers?.length !== oldVal?.query?.layers?.length ||
        newVal?.query?.year !== oldVal?.query?.year
      ) {
        this.refreshMap()
      }
    },
    moveendHandler() {
      if (this.map) {
        let latlng = this.map.getCenter()
        this.replaceRoute({ center: [latlng.lat, latlng.lng], optimizeThreads: this.optimizeThreads || null })
      }
    },
    zoomHandler() {
      if (this.map) {
        this.replaceRoute({ zoom: this.map.getZoom(), optimizeThreads: this.optimizeThreads || null })
      }
    },
    async replaceRoute(opts, skipAsyncData = true) {
      let route = url.getRoute(this.$route)
      for (let key in opts) {
        // vue.js have bug in array query properties
        // use coma separated values
        if (Array.isArray(opts[key])) {
          route.query[key] = opts[key].join(',')
        } else if (!opts[key]) {
          route.query[key] = null
        } else {
          route.query[key] = opts[key]
        }
      }
      for (let key in route.query) {
        // be careful with 0
        if (!route.query[key]) {
          delete route.query[key]
        }
      }
      
      // unset center with properties near the zero
      if (route.query.center) {
        let [lat, lng] = route.query.center.split(',')
        if (+lat < 1 || +lng < 1) {
          delete route.query.center
        }
      }
      
      this.$store.commit('skipAsyncData', { name: this.$route.name, value: skipAsyncData })
      
      // for disable global isReplace handler
      route.isReplace = false
      await this.$router.replace(route, (e) => {});
    },
    /* required for use in map-poup.vue */
    registerClosePopup() {
      this.replaceRoute({ openedPopupInfo: null, lastEventPos: null })
    },
    /* required for use in map-poup.vue */
    registerOpenPopup(marker) {
      if (marker.options.openedPopupInfo) {
        console.log('registerOpenPopup ', marker)
        // lastEventPos - need for register correct relation popup pos
        this.replaceRoute({ openedPopupInfo: marker.options.openedPopupInfo, lastEventPos: marker.options.lastEventPos })
      }
    },
    getObjectDrawer() { return this.objectDrawer ? this.objectDrawer : new ObjectDrawer(this.map, this) }
  }
}
